// FROM https://usehooks.com/useLocalStorage/

import { useEffect, useState } from 'react';

// Hook
export function useLocalStorage(key: string, initialValue: any) {
  const readFromLocalStorage = () => {

    try {
      const item = window.localStorage.getItem(key);
      setStoredValue(item ? JSON.parse(item) : initialValue);
    } catch (error) {
      console.error(error);
    }
  };
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.error(error);
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value: any) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
      // Send a window event to notify other tabs that the value has changed
      window.dispatchEvent(new Event(`storage-${key}`));
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.error(error);
    }
  };

  // listen to window events to refresh value across instances
  useEffect(() => {
    window.addEventListener(`storage-${key}`, readFromLocalStorage, false);

    return () => window.removeEventListener(`storage-${key}`, readFromLocalStorage);
  }, [key]);

  return [storedValue, setValue];
}
